import { useCallback, useState } from 'react';

/**
 * Номер страницы списка, который возвращается на первую, когда меняется то, что задаёт
 * выборку: период, фильтры. Область (`scope`) — строка, собранная из них.
 *
 * Раньше «Клиенты» и «Жалобы» при смене периода оставались на прежней странице: третья
 * страница нового периода часто пуста или вовсе за пределами списка, а «Страница 3 из 1»
 * выглядела поломкой. Сброс эффектом (`useEffect(() => setPage(1), [...])`) сначала
 * запрашивает старую страницу с новым периодом и только потом первую; здесь первая страница
 * выводится из состояния в том же рендере, и запрос уходит один.
 */
export const resolvePage = (state, scope) => (state.scope === scope ? state.page : 1);

/** Следующее состояние: `next` — число или функция от текущей страницы, как у `setState`. */
export const nextPageState = (state, scope, next) => {
  const current = resolvePage(state, scope);
  return { scope, page: typeof next === 'function' ? next(current) : next };
};

const usePageForScope = (scope) => {
  const [state, setState] = useState(() => ({ scope, page: 1 }));

  const setPage = useCallback((next) => setState((prev) => nextPageState(prev, scope, next)), [scope]);

  return [resolvePage(state, scope), setPage];
};

export default usePageForScope;
